export default {
  data() {
    return {
      // 项目属性
      projectAttr: [],
      radio: 0,
      //项目地区目录
      projectArea: [{ id: 0, name: '全部' }],
      Area: '0',
      //项目类型目录
      projectType: [{ id: 0, name: '全部' }],
      Type: '0',
      //项目等级标签
      ProjectRank: [{ id: 0, name: '全部' }],
      Rank: '0',
      //时间标签
      ProjectTime: ['全部'],
      Time: '全部',
      //当前时间
      currentTime: '',
      //项目列表
      ProjecList: [],
      //搜索传值
      data: '',

      //分页总条数
      total: 0,
      offset: 0,
      refname: '',
      length: 15,
      prev: '',
      pager: '',
      next: '',
      // end:分页

      checklist: {},

      labels: [],
      packageData: [],

      // 地区列表
      regionList: [],
      // 项目等级列表
      projectLevelList: [],
      // 学段列表
      gradeList: [],
      // 年份列表
      yearList: [],
      // 筛选的条件列表
      conditions: [],
      // 搜索关键字
      search: '',
      // 默认选中的单选框
      checked: '',
      // 处理过后的数组
      list1: [],
      list: []
    }
  },
  methods: {
    // 搜索出店铺的属性和对应的属性值
    getShopAttr() {
      this.$post('attribute/search', {
        token: this.$store.state.id,
        offset: 0,
        length: 9999,
        shop_id: this.$store.state.store.id
      })
      .then(res => {
        if (res.status === 200) {
          let projectAttr = res.data.result.data
					// // console.log('arr',projectAttr	)
          for (let i = 0; i < projectAttr.length; i++) {
            this.labels.push(projectAttr[i].name)
            // 在主页选择某个属性后, 跳转到当前页, 在筛选的区域会默认选择这个属性
            if (i === 0) {
              projectAttr[0].name = this.checked
            }
          }
          this.projectAttr = projectAttr
          this.getPackageAttr()
        }
      })
    },

    // 根据条件获取项目包及其相关属性
    // getPackageAttr() {
    //   this.$post('package/search_package', {
    //     offset: 0,
    //     length: 9999
    //   }).then(res => {
    //     if (res.status === 200) {
    //       this.packageData = res.data.result.data
    //       this.projectAttr.map(item => (
    //         this.labels.push(item.name)
    //       ))
    //       // // console.log(packageData)
    //       // let projectAttr = this.projectAttr

    //       // let tableData = []
    //       // for (let i = 0; i < projectAttr.length; i++) {
    //       //   let name = {name: projectAttr[i].name}
    //       //   tableData.push(name)
    //       // }
    //       // tableData = tableData.reverse()
    //       // // console.log(tableData)
    //       // for (let i = 0; i < packageData.length; i++) {
    //       //   for (let j = 0; j < packageData[package_attribute_value].length; j++) {

    //       //   }
    //       // }
    //     }
    //   })
    // },

    // 处理单选框改变事件
    handleChange() {
      let projectAttr = this.projectAttr
      let conditions = []
      // // console.log('arr11', projectAttr)
      for (let i = 0; i < projectAttr.length; i++) {
        let num = projectAttr[i].name
        var reg = /^[0-9]+.?[0-9]*$/
        if (reg.test(num)) {
          conditions.push(num * 1)
        }
      }
      this.conditions = conditions
      this.getPackageAttr()
    },
    // 根据获取到的数据向后台发送请求
    getPackageAttr() {
      // // console.log('调用我了，我是getPackageAtt')
      // // console.log('拿到', this.conditions)
      let conditions = this.conditions.map(item => (
        item * 1
      ))
      //发送给后台的数据
      let data = {
        offset: 0,
        length: 9999,
        shop_id: this.$store.state.store.id
      };
      //判断条件数组是否有值
      if (conditions.length !== 0) {
        data.id_arr = JSON.stringify(conditions);
      }
      this.$post('package/search_package', data).then(res => {
        // // console.log('怎么', res.status);
        if (res.status === 200) {
          // console.log('66666', res.data.result.result.data);
          this.packageData = res.data.result.result.data
          this.handleArray(this.packageData)
					// // console.log("packData",this.packageData,"handArr",this.handleArray)
        }
      })
    },
    //根据名字搜索项目包
    accordingNameSearch() {
      // // console.log('调用我了，我是accordingNameSearch')
      // // console.log('搜索的关键字为 ' + JSON.stringify(this.search))
      this.$post('package/search_package', {
        offset: 0,
        length: 9999,
        name: this.search,
        shop_id: this.$store.state.store.id
      }).then(res => {
        if (res.status === 200) {
          // // console.log(res)
          this.packageData = res.data.result.result.data
          this.handleArray(this.packageData)
          // // console.log('搜索返回的值为：')
          // console.log('packData',this.packageData)
        }
      })
    },
    // 计算状态
    state(start_stydy_time, end_study_time) {
      let time = new Date().getTime()
      if (time > end_study_time) {
        return "已结束"
      } else if (time < end_study_time && time > start_stydy_time) {
        return "进行中"
      } else {
        return "未开始"
      }

    },
    //获取项目列表
    getProjectList() {
      let Area, Rank, Type, Time
      if (this.Type == 0) { Type = '' } else { Type = this.Type }
      if (this.Rank == 0) { Rank = '' } else { Rank = this.Rank }
      if (this.Area == 0) { Area = '' } else { Area = this.Area }
      if (this.Time == '全部') { Time = '' } else { Time = this.Time }

      this.$post('products/search_project', {
        token: this.$store.state.id,
        offset: 0,
        length: this.length,
        product_area_id: Area,
        product_rank_id: Rank,
        product_type_id: Type,
        year: Time
      }).then(res => {
        this.ProjecList = res.data.result.data
        this.total = res.data.result.total
        //  // console.log('项目列表:', res.data.result)
      })
    },

    // 获取项目地区标签
    // getProjectArea(){
    //   this.$post('product_area/search',{
    //     token:this.$store.state.id,
    //     offset:0, 
    //     length:9999,
    //     shop_id:this.$store.state.store.id
    //   }).then(res=>{
    //       res.data.result.data.map(res=>{
    //         this.projectArea.push(res)
    //       })
    //       // // console.log('项目地区标签:',this.projectArea)
    //   })
    // },

    // //获取项目类型标签
    // getProjectType(){
    //   this.$post('product_type/search',{
    //     token:this.$store.state.id,
    //     offset:0, 
    //     length:9999,
    //     shop_id:this.$store.state.store.id
    //   }).then(res=>{
    //       res.data.result.data.map(res=>{
    //         this.projectType.push(res)
    //       })
    //       // // console.log('项目类型标签:', this.projectType)
    //   })
    // },

    // //获取项目等级标签
    // getProjectRank(){
    //   this.$post('product_rank/search',{
    //     token:this.$store.state.id,
    //     offset:0, 
    //     length:9999,
    //     shop_id:this.$store.state.store.id
    //   }).then(res=>{
    //       res.data.result.data.map(res=>{
    //         this.ProjectRank.push(res)
    //       })
    //       // // console.log('项目等级标签:', this.ProjectRank)
    //   })
    // },

    // //获取时间标签
    // getProjectTime(){
    //   this.changeDate()
    //   for(let i=this.currentTime;i>2016;i--){
    //     this.ProjectTime.push(i)
    //   }
    // },

    //获取当前时间
    changeDate() {
      let date = new Date(+new Date() + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
      this.currentTime = date.slice(0, 4)
    },



    toProjectHomePage(obj) {
      this.$router.push({
        path: '/pojecthomepage',
        query: {
          id: obj.id
        }
      });
    },
    // toProject(res) {
    //   // console.log(res)
    //   this.$router.push({
    //     path: '/lessonstudy',
    //     query: {
    //         id: res.id
    //     }
    //   })
    // },
    // //选中按钮变色
    // selected(name,index,type){
    //   this.selectedIndex[type] = index;
    //   // alert(this.selectedIndex)
    //   if(type == 0){
    //     this.refname = 'year' + index;
    //     this.length = this.year.length

    //   }
    //   else if(type == 1){
    //     this.refname = 'type' + index;
    //     this.length = this.projectType.length
    //   }
    //   else if(type == 2){
    //     this.refname = 'leaval' + index;
    //     this.length = this.projectLv.length
    //   }
    //   else{
    //     this.refname = 'region' + index;
    //     this.length = this.projectRegion.length
    //   }
    // },
    // 清除同行其他按钮颜色
    cleartype(index, type) {
      let name = this.charname[type];
      for (let i = 0; i < this.length; i++) {
        if (index != i) {
          this.$refs[name + i][0].type = "default";
        }
      }
    },

    //分页函数
    change(res) {
      // alert(res)
      this.offset = (res - 1) * this.length
      let Area, Rank, Type, Time
      if (this.Type == 0) { Type = '' } else { Type = this.Type }
      if (this.Rank == 0) { Rank = '' } else { Rank = this.Rank }
      if (this.Area == 0) { Area = '' } else { Area = this.Area }
      if (this.Time == '全部') { Time = '' } else { Time = this.Time }

      this.$post('products/search_project', {
        token: this.$store.state.id,
        offset: this.offset,
        length: this.length,
        product_area_id: Area,
        product_rank_id: Rank,
        product_type_id: Type,
        year: Time
      }).then(res => {
        this.ProjecList = res.data.result.data
        this.total = res.data.result.total
        // // console.log('项目列表:', res.data.result)
      })

    },
    //搜索
    sousuo() {
      this.$post('products/search_project', {
        token: this.$store.state.id,
        offset: 0,
        length: 9999,
        name: this.data
      }).then(res => {
        this.ProjecList = res.data.result.data
        this.total = res.data.result.total
        //  // console.log('项目列表:', res.data.result)
      })
    },

    // 处理初始数组的数据
    handleArray(arr) {

      let table = []
      let labels = this.labels
      let list = []

      for (let k = 0; k < labels.length + 2; k++) {
        // // console.log('进来循环了')
        table.push('-')
      }

      for (let i = 0; i < arr.length; i++) {

        for (let j = 0; j < arr[i].package_attribute_value.length; j++) {

          for (let k = 0; k < labels.length; k++) {

            if (arr[i].package_attribute_value[j].attribute_type_name === labels[k]) {
              table.splice(k, 1, arr[i].package_attribute_value[j].attribute_value_name)
            }

          }
        }


        table.splice(labels.length, 1, arr[i].name)
        table.splice(labels.length + 1, 1, this.state(arr[i].start_stydy_time, arr[i].end_study_time))

        list.push(table)

        table = []
        for (let k = 0; k < labels.length + 2; k++) {
          table.push('-')
        }

      }
      this.list1 = list
      // // console.log(this.list1)


      // // console.log(arr)
      // let labels = this.labels

      // let list = []
      // for (let i = 0; i < arr.length; i++) {
      //   let data = {}
      //   data.id = arr[i].id
      //   data.attribute_value_id = arr[i].attribute_value_id
      //   data.name = arr[i].name
      //   data.start_stydy_time = arr[i].start_stydy_time
      //   data.end_study_time = arr[i].end_study_time
      //   data.package_attribute_value = []

      //   for (let j = 0; j < arr[i].package_attribute_value.length; j++) {
      //     let type = arr[i].package_attribute_value[j].attribute_type_name
      //     let value =  arr[i].package_attribute_value[j].attribute_value_name
      //     data[type] = value
      //   }
      //   list.push(data)
      // }
      // // console.log(list)
      // this.list = list

      // let arrtList = []
      // for (let i = 0; i < arr.length; i++) {
      //   let data = {}
      //   data.id = arr[i].id || '-'
      //   data.attribute_value_id = arr[i].attribute_value_id || '-'
      //   data.name = arr[i].name || '-'
      //   data.start_stydy_time = arr[i].start_stydy_time || '-'
      //   data.end_study_time = arr[i].end_study_time || '-'
      //   arrtList.push(data)
      // }
      // this.list = arrtList
      // // console.log(this.list)
    },
		getPackID(item){
			let packNameLength = item.length - 2
			for(let i=0;i<this.packageData.length;i++){
				
				if(item[packNameLength] == this.packageData[i].name){
					// this.$router.push({path:'/pojecthomepage',query:{id:this.packageData[i].id}})
					this.$post('package/get_package', {
            id: this.packageData[i].id
          }).then(res => {
            let url = res.data.result.url
            location.href = url
          })
				}
			}
			
		}
  },

  mounted() {
    this.search = this.$route.query.data
    // // console.log('idarr', this.$route.query.id_arr);
    if (this.$route.query.id_arr !== undefined) {
      this.checked = JSON.parse(this.$route.query.id_arr)[0]
      // // console.log('this.checked = ' + this.checked)
    }
    //判断如果有传名字过来则用名字搜索
    // // console.log(this.search);
    if (this.search) {
      // // console.log('进行搜索')
      this.accordingNameSearch();
    } else if (this.$route.query.id_arr) {
      //是否用地区筛选
      this.conditions = JSON.parse(this.$route.query.id_arr);
      // // console.log('this.conditions = ' + this.conditions)
      // this.getPackageAttr();
    }
    // this.getProjectArea()
    // this.getProjectType()
    // this.getProjectRank()
    // this.getProjectTime()
    // if(this.$route.query.product_area_id){
    //   this.Area = this.$route.query.product_area_id
    // }
    // if(this.$route.query.data){
    //   this.data = this.$route.query.data
    //   this.sousuo()
    // }else{
    //   this.getProjectList()
    // }
  },

  created() {
    this.getShopAttr();
  }
}